module.exports = __webpack_public_path__ + "img/oao_logo_blue.7b9f3cbc.png";